import { RacwaSplashScreen } from "@racwa/react-components";

export const Form = () => <RacwaSplashScreen />;

export default Form;
